import Header from "../components/Header";
import ProfileDash from "../components/ProfileDash";

export default function Profile() {
  return (
    <>
      <Header />
      <ProfileDash />
    </>
  );
}